const cardItems = [
  {
    id: 1,
    title: '从素人到顶流：2026年最励志的逆袭故事',
    desc: '一年前还默默无闻，如今已是热搜常客。这位新生代偶像的走红之路充满戏剧性。',
    tag: '人物',
    imageUrl: 'https://readdy.ai/api/search-image?query=Inspirational%20success%20story%20abstract%20illustration%20with%20rising%20arrow%20and%20star%20elements%2C%20warm%20coral%20and%20gold%20gradient%2C%20modern%20editorial%20design%2C%20clean%20minimal%20background%2C%20magazine%20layout%20style&width=400&height=250&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '综艺节目为什么越来越"卷"？业内人揭秘制作幕后',
    desc: '从嘉宾阵容到场景设计，从游戏环节到后期剪辑，一档现象级综艺的诞生并不简单。',
    tag: '深度',
    imageUrl: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20TV%20production%20abstract%20illustration%20with%20camera%20and%20clapperboard%20motifs%2C%20warm%20amber%20and%20deep%20coral%20palette%2C%20modern%20flat%20design%2C%20clean%20composition%2C%20cinematic%20aesthetic&width=400&height=250&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '吃瓜群众的自我修养：如何理性看待网络热点',
    desc: '在信息爆炸的时代，做一个有态度的吃瓜人，不盲从、不传谣、不网暴。',
    tag: '观点',
    imageUrl: 'https://readdy.ai/api/search-image?query=Digital%20media%20literacy%20abstract%20illustration%20with%20magnifying%20glass%20and%20speech%20bubbles%2C%20warm%20orange%20and%20soft%20rose%20tones%2C%20modern%20minimal%20design%2C%20clean%20geometric%20background&width=400&height=250&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '今年暑期档电影票房黑马是如何炼成的？',
    desc: '没有大牌明星、没有巨额投资，这部小成本电影凭什么拿下暑期档票房冠军？',
    tag: '影视',
    imageUrl: 'https://readdy.ai/api/search-image?query=Box%20office%20success%20movie%20abstract%20illustration%20with%20ticket%20and%20popcorn%20elements%2C%20warm%20coral%20and%20gold%20color%20scheme%2C%20modern%20cinematic%20design%2C%20clean%20flat%20composition%2C%20editorial%20style&width=400&height=250&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '那些年我们追过的CP：从荧幕情侣到现实恋人',
    desc: '有些CP只存在于剧本里，有些却走进了现实。盘点那些让观众上头的神仙CP。',
    tag: '盘点',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20couple%20chemistry%20abstract%20illustration%20with%20heart%20and%20sparkle%20motifs%2C%20warm%20pink%20and%20coral%20gradient%2C%20modern%20minimal%20design%2C%20soft%20geometric%20shapes%2C%20clean%20composition&width=400&height=250&seq=card-05&orientation=landscape',
  },
  {
    id: 6,
    title: '音乐节扎堆的夏天：哪一场最值得去？',
    desc: '从南到北，各大音乐节争奇斗艳。阵容、场地、票价全方位对比，帮你做出选择。',
    tag: '音乐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20festival%20abstract%20illustration%20with%20stage%20and%20crowd%20silhouettes%2C%20warm%20amber%20and%20coral%20color%20palette%2C%20modern%20flat%20design%2C%20festive%20atmosphere%2C%20clean%20geometric%20composition&width=400&height=250&seq=card-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            精选好文
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[500px] mx-auto">
            深度内容，带你看到吃瓜背后的故事
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardItems.map((item) => (
            <article key={item.id} className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/60 transition-all duration-300 hover:border-primary-200 cursor-pointer">
              <div className="overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full aspect-[16/10] object-cover transition-transform duration-500 group-hover:scale-105"
                  width="400"
                  height="250"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block text-xs font-bold text-primary-500 bg-primary-50 px-2 py-0.5 rounded mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2 leading-snug line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}